module.exports = "<span class=p-ref-a>{{prop}}: <a :href=\"'#'+value\">{{ value }}</a></span>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ItemRef.vue
 ** module id = 140
 ** module chunks = 0
 **/